import { Island } from '../../islands/island.class';
import { Panel } from '../panel.class';
import { Vertex3 } from '../../../spatial-classes';
import { getPanelLayoutInputCfn } from './panel-layout-input.cfn';
import { planGroupLayoutCfn } from './plan-group-layout.cfn';

/**
 * Evenly distributes the panel's appliance columns.
 *
 * The arithmetic lives in `planGroupLayoutCfn` (pure); this function only
 * builds the planner's input from the model and writes the plan back. Locked
 * columns keep their place and split the run into segments; vent / passthrough
 * columns are neither moved nor treated as obstacles; a run wider than the
 * panel is packed and centred with overhang.
 *
 * Every unlocked column is assigned (and so publishes `panel_item_group.moved`)
 * even when its x does not change — the behaviour callers have always relied on.
 */
export const distributeApplianceGroupsHorizontallyCfn = (panel: Panel): void => {
	const island = panel.refMap.island as Island;

	if (island === null) {
		console.warn('distributeApplianceGroupsHorizontally: panel and island must be supplied');
		return;
	}

	const input = getPanelLayoutInputCfn(panel);
	const unlockedIds = new Set(input.groups.filter((g) => g.distributable && !g.locked).map((g) => g.id));

	if (unlockedIds.size === 0) {
		return;
	}

	const positions = planGroupLayoutCfn(input);
	const groupsById = new Map(panel.panelItemGroups.children.map((g) => [g.id, g] as const));

	for (const { id, x } of positions) {
		if (!unlockedIds.has(id)) continue;
		const group = groupsById.get(id);
		if (group) group.center = new Vertex3({ dataIn: { x }});
	}
};
